/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

export default {
  energyManagement: {
    REFRESH: 'Actualizar',
    ENERGYPERFORMANCE: 'Ahorro de energía',
    UTILITYBILLSAVINGS: 'Cargos por facturas de servicios públicos ',
    DateFrom: 'Fecha desde',
    SITES: 'Sitios',
    ENERGYMANAGEMENTDASHBOARDTITLE: 'Puntaje de gestión de energía',
    BASELINE: 'Valor de referencia',
    BASELINEKEY: 'Consumo de referencia',
    ACTUALKEY: 'Consumo real',
    SAVINGS: 'Ahorro',
    ACTUAL: 'Real',
    PARTIAL_MONTH: 'Mes parcial',
    ACTUALEMISSIONS: 'Emisiones reales',
    ACTUALEMIS: 'Emis. actuales',
    PREVIOUSEMIS: 'Emis. anteriores',
    PREVIOUSEMISSIONS: 'Emisiones anteriores',
    TOTALCONSUMPTION: 'Consumo total',
    EMISSION: 'Emisiones',
    ACTUALAVOIDANCE: 'Ahorro real',
    PREVIOUSPERIOD: 'Periodo anterior',
    PREVIOUS: 'Anterior',
    PREVIOUSAVOIDANCE: 'Ahorro anterior',
    ACTUALCOST: 'Costo real',
    actualCost: 'CONS. REAL',
    BASELINECOST: 'Costo de referencia',
    baselineCost: 'CONS. DE REFERENCIA',
    PREVSPER: 'PERIODO ANTERIOR',
    PREVIOUSCOST: 'Costo anterior',
    VIEWDETAILS: 'VER DETALLES',
    ADVANCED: 'Avanzado',
    BASIC: 'Básico',
    MONTHLY: 'Mensual',
    BILLING: 'Facturación',
    LIVEMETER: 'Medidores en tiempo real',
    UTILITYMETER: 'Medidores de servicios públicos',
    LIVEREADING: 'Medidores en sitio',
    UTILITYINTERVAL: 'Intervalo de servicios públicos',
    UTILITYPROVIDERNEW: 'Servicios públicos mensuales',
    ACTUALCONSUMPTION: 'Consumo real',
    BASELINECONSUMPTION: 'Consumo de referencia',
    PREDICTED: 'Previsión',
    Utilitycost: 'Costo de servicios públicos para',
    UtilityBill: 'Descripción general de la factura de servicios públicos',
    UtilityCost: 'Costo de los servicios públicos',
    ActualCost: 'Costo real',
    CostPercentage: '% costo',
    Electricity: 'Electricidad',
    Gas: 'Gas',
    Water: 'Agua',
    UtilityType: 'Tipo de servicio público',
    all: 'todo',
    electricity: 'electricidad',
    gas: 'gas',
    water: 'agua',
    BASICSITEWITHDATACOUNTMESSAGE:
      '* Se han generado facturas de servicios públicos por consumo de energía para {siteWithDataCount} de {totalSiteCount} sitios.',
    CARBONUTILITYGRAPHTOOLTIP:
      '* Se han generado emisiones por facturas de servicios públicos para {siteWithDataCount} de {totalSiteCount} sitios.',
    CARBONLIVEGRAPHTOOLTIP:
      '* Se han generado emisiones para lecturas en tiempo real para {siteWithDataCount} de {totalSiteCount} sitios.',
    ENERGYUTILITYGRAPHTOOLTIP:
      '* Se han generado consumos de energía de facturas de servicios públicos para {siteWithDataCount} de {totalSiteCount} sitios.',
    ENERGYLIVEGRAPHTOOLTIP:
      '* Se han generado lecturas en tiempo real para {siteWithDataCount} de {totalSiteCount} sitios.',
    UtilityTypeforselectutility: 'Tipo de servicio público*',
    ENABLEIDSCHECKBOX: 'Habilitar IDS (Servicio de datos de intervalo)',
    ENABLED: 'Habilitado',
    DISABLED: 'Deshabilitado',
    CONVERSIONINFOMSG:
      'Proporcione sus credenciales para habilitar la conversión de este número de cuenta de un tipo de integración “Manual” a “Automático”. Una vez que el \n    credenciales sean verificadas, el tipo de integración se actualizará automáticamente. Los datos guardados manualmente se conservarán y las próximas facturas \n    se actualizará automáticamente después.',
    CO2: 'CO2',
    CARBON: 'Carbono({unit})',
    CARBONNOUNIT: 'Carbono',
    CARBONEMISSION: 'Emisiones de carbono',
    METERDATA1: 'Datos de medidores',
    DATANEEDED: 'Data necesarios',
    METERDATA: 'Datos de medidores',
    METERDATASUBTITLE:
      'Analice y compare el consumo del medidor cargando datos históricos o de períodos faltantes.',
    EUI: 'EUI({preferredEuiUnit})',
    ELECTRICITYCONSUMPTION: 'CONSUMO DE ELECTRICIDAD',
    ELECTRICITYPERFORMANCE: 'Rendimiento eléctrico',
    Electicity:
      ' Los datos de electricidad, gas y agua se pueden integrar con la vinculación de sus cuentas.',
    FORECAST: 'Pronóstico',
    ALL: 'Todo',
    ELECTRICITY: 'Electricidad',
    GAS: 'Gas',
    WATER: 'Agua',
    METER: 'MEDIDOR',
    SavingMeter: 'Ahorro por medidor',
    BREAKDOWNMETER: 'Cons. por medidores',
    BREAKDOWNBYAREAS: 'Desglose por áreas',
    BREAKDOWNBYEQUIPMENTTYPE: 'Desglose por tipo de equipo',
    CONSUMPTIONBYUTILITIES: 'Cons. por servicios públicos',
    ENERGYBREAKDOWNOFUTILITY: 'Desglose de servicios públicos',
    ENERGYBREAKDOWNBYMETERS: 'Desglose por medidores',
    WATERBREAKDOWNBYLIVEMETERS: 'Desglose por medidores en tiempo real',
    BREAKDOWNOFUTILITY: 'Desglose de cargos de servicios públicos',
    breakdownUtility: 'Desglose por servicios públicos',
    breakdownCarbon: 'Desglose de medidores',
    breakdownCarbonScopeOne: 'Desglose por categoría',
    breakdownFuel: 'Desglose de tipos de combustible',
    breakdownAreas: 'Desglose por áreas',
    areasHeader: ' Áreas',
    metersHeader: 'Medidores',
    areasSubHeaders:
      'El siguiente desglose del consumo de electricidad es por zonas y para la duración seleccionada.',
    baselinebutton: 'Crear referencia',
    LAST_BASELINE_TRAINED_DATE: 'Última línea de referencia capacitada en',
    apply: 'Aplicar',
    back: 'Atrás',
    baselinetraning: 'Capacitación de referencia',
    chooseTrainingDateRange: 'Elegir el rango de fechas de capacitación',
    applyBaselineFrom: 'Aplicar línea base desde',
    historicDataTooltip:
      'Para los datos históricos cargados, la referencia será visible para los últimos 15 días en el Panel de control y en los informes.',
    excludeSpecificDateRangeQ:
      '¿Prefieres excluir un rango de fechas específico?',
    excludeDateRange: 'Excluir rango de fechas',
    howitworks: '¿Cómo funciona?',
    howitworksone:
      'Todos los datos del medidor cargados se utilizarán para entrenar un modelo de referencia de buena calidad.',
    howitworkstwo:
      'Los datos de referencia se mostrarán en el Panel de control y en los informes de los últimos 15 días a partir de la fecha de carga.',
    howitworksthree:
      'Para lograr mejores resultados de referencia, se recomienda tener 12 meses de datos.',
    howitworksfour:
      'Se necesitan un mínimo de 30 días de datos para el entrenamiento del modelo.',
    howitworksfive:
      'El entrenamiento de referencia se aplica a los datos de todos los medidores del sitio.',
    howitworkssix:
      'Cuando se vuelve a entrenar el modelo de referencia, el modelo existente se reemplazará en función del nuevo período de capacitación de referencia.',
    baselinedaterangeheader: 'Elegir el período de capacitación de referencia',
    baselinedaterangesubheader:
      'Seleccione el rango de fechas para el modelo de referencia, si desea incluir o excluir un período específico.',
    redirectmsg1: 'Será redirigido en',
    redirectmsg2: 's',
    uploadingmsg:
      'Espere mientras iniciamos el proceso para entrenar la línea base y le notificaremos por correo electrónico una vez que se haya completado.',
    meterSubHeaders:
      'La tabla proporciona un desglose de los medidores en el sitio junto con varios KPI.',
    breakdownCarbonSites: 'Emisiones de carbono por sitios ({count})',
    ENERGYUSAGE: 'Consumo de energía',
    ENERGYUSAGECONSUMPTION: 'Consumo',
    USAGEConsumption: 'Consumo',
    WATERUSAGE: 'Uso del agua',
    NILMTOOLTIPHEADER: 'Monitoreo de carga no intrusivo (NILM)',
    NILM: 'NILM',
    ENERGYDISAGGREGATION: 'Desagregación de energía',
    ENERGYUSAGEOVERVIEW: 'Descripción general del consumo de energía',
    CONSUMPTIONOVERVIEW: 'Resumen de consumo',
    LOADING: 'Cargando',
    SUBMITTING: 'Enviando',
    NODATAAVAILABLE: 'No hay datos para el período seleccionado',
    UTILITYYEAROUTOFRANGE: 'Seleccione un rango de fechas dentro de un año',
    NOTSUBSCRIBED: 'Sin suscripción',
    CONNECTIONERROR: 'No pudimos conectarnos al\nservicio. Vuelva a intentarlo',
    CONNECTIONERRORTITLE: 'Error de conexión.',
    WATERTOOLTIPHEADER: 'Consumo de agua',
    CARBONSAVINGSMETERHEADER: 'Emisiones por categoría',
    CARBONKPIDETAILS: 'Emisiones de carbono para',
    ENERGYUSAGEDETAILS: 'Consumo de energía para',
    WATERUSAGEDETAILS: 'Uso del agua para',
    CarbonSavingMeter: 'Ahorro por servicio público',
    SITENAMESHEADER: 'Desglose por sitios',
    CARBONTOOLTIPHEADER: 'Emisiones de carbono',
    GASTOOLTIPHEADER: 'Ahorro de energía en gas',
    ALLTOOLTIPHEADER: 'Ahorro de energía',
    METEROVERVIEW: 'Descripción general del medidor',
    METERANALYSIS: 'Análisis del medidor',
    ID: 'ID',
    TYPE: 'Tipo',
    DEVIATION: 'Desviación',
    HIGH: 'Alto({unit})',
    HIGHWITHOUTUNIT: 'Alto',
    LOW: 'Bajo({unit})',
    LOWWITHNOUNIT: 'Bajo',
    ENERGY: 'Energía({unit})',
    ENERGYNOUNIT: 'Energía',
    CHANGE: 'Cambio',
    CARBONTAB: 'Carbono (CO2e)',
    ENERGYTAB: 'Energía',
    WATERTAB: 'Agua',
    EUITAB: 'EUI',
    UTILITYCOST: 'Utilidad',
    actualConsumption: 'CONSUMO REAL',
    actualCons: 'CONS. REAL',
    baselineConsumption: 'CONSUMO DE REFERENCIA',
    baselineCons: 'CONS. DE REFERENCIA',
    ConsumptionSavingsPercentage: '% AHORRO EN CONS.',
    ConsumptionChange: 'CAMBIO DE CONS.',
    ConsSavings: 'AHORRO EN CONS.',
    utiltactualCost: 'COSTO REAL',
    utilpreviousCost: 'COSTO ANTERIOR',
    SavingsPercentage: '% AHORRO',
    utilchange: 'CAMBIO',
    NODATA: 'Sin datos',
    ENERGYKPIDETAILS: 'Rendimiento eléctrico para',
    ENERGYPERFORMANCEALL: 'Rendimiento energético',
    NILMENERGYUSAGE: 'Consumo de energía',
    NILMENERGYUSAGESUBHEADER:
      'El gráfico muestra el consumo de energía durante el período seleccionado.',
    ALLKPICARDDETAILS: 'Rendimiento energético para',
    WATERCONSUMPTIOND: 'Consumo de agua para',
    ENERGYCONSUMPTIONMETER: 'Consumo por medidor',
    WATERCONSUMPTION: 'Consumo de agua',
    ALLUTILITIES: 'Todos los servicios públicos',
    ALLEnergySources: 'Todas las fuentes de energía',
    WaterPerformance: 'Rendimiento del agua',
    WaterOverview: 'Descripción general del agua',
    GASPERFORMANCE: 'Rendimiento del gas para',
    GASPERFORMANCEDETAILS: 'Rendimiento del gas',
    WATERPERFORMANCEDETAILS: 'Rendimiento del agua',
    SEWERAGEPERFORMANCE: 'Rendimiento del alcantarillado',
    ALLSAVINGSBYUTILITY: 'Ahorro de BTU por servicio público',
    TOTALENERGYCOST: 'Costo total de energía',
    TOTALSAVINGS: 'Ahorros totales',
    TOTALFOOTSPRINT: 'Huella total',
    INTEGRATIONTYPE: 'TIPO DE INTEGRACIÓN',
    UTILITYPROVIDER: 'PROVEEDOR DE SERVICIOS PÚBLICOS',
    ACCOUNTNUMBER: 'NÚMERO DE CUENTA',
    STATUS: 'ESTADO',
    UDSSTATUS: 'Estado de servicios públicos',
    IDSSTATUS: 'Estado de servicio de datos de intervalo',
    ACTIONS: 'ACCIONES',
    SERVICESOVERVIEW: 'Descripción general de los servicios',
    AddService: 'AÑADIR SERVICIO',
    AllServices: 'Todos los servicios',
    Active: 'Activo',
    Inactive: 'Inactivo',
    Sewerage: 'Alcantarillado',
    ServiceProvider: 'Proveedor de servicios',
    AccountNumber: 'Número de cuenta',
    CANCEL: 'CANCELAR',
    SELECTALL: 'Seleccionar todo',
    SEARCH: 'Buscar',
    SHOWACCOUNTNUMBERS: 'Mostrar todos los números de cuenta',
    BACK: 'ATRÁS',
    SUBMIT: 'ENVIAR',
    Complete: 'COMPLETA',
    DONE: 'LISTO',
    Utillity: 'Utilidad',
    AllUtilityService: 'Todos los servicios públicos',
    Weather: 'Clima',
    WeatherServices: 'Servicios meteorológicos',
    Weatherdata:
      'Los datos meteorológicos se pueden integrar con la vinculación de sus cuentas.',
    CONFIGURE: 'CONFIGURAR',
    METERID: 'ID DE MEDIDOR',
    SERVICETYPE: 'TIPO DE SERVICIO',
    METERINGPURPOSE: 'PROPÓSITO DE MEDICIÓN',
    SITESETTINGS: 'Configuración del sitio',
    SERVICESINTEGRATION: 'Servicios',
    USERMANAGEMENT: 'Administr. usuarios',
    GENERALSETTINGS: 'Configuración general',
    UTILITYBILLTOOLTIPHEADER: 'Factura de servicios públicos',
    UTILITYBILLDETAILSTOOLTIPHEADER: 'Rendimiento de servicios públicos',
    ELECTRICITYTOOLTIPHEADER: 'Ahorro de energía en electricidad',
    WATERTOOLTIPCONTENT:
      'Comparación del consumo de agua para la duración seleccionada a partir de los datos reales con respecto a los datos del año de referencia',
    UTILITYBILLOVERVIEWTOOLTIPCONTENT:
      'Costo calculado para la duración seleccionada a partir de datos reales con respecto a los del año anterior. Nota: El costo se calcula en función de los meses calendario y no es específico de los períodos de facturación de servicios públicos.',
    UTILITYBILLTOOLTIPCONTENT:
      'Uso y costo calculados para la duración seleccionada a partir de datos reales con respecto a los del año anterior. Nota: El costo se calcula en función de los meses calendario y no es específico de los períodos de facturación de servicios públicos.',
    CARBONTOOLTIPCONTENT:
      'Emisión calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior. ',
    DATANEEDEDCONTENT:
      'Faltan datos de alcance 1, revise y actualice los datos cada mes',
    CARBONTOOLTIPSECONDCONTENT:
      'Los cálculos de CO2 en tiempo real se basan en el medidor principal, y los cálculos precisos de carbono se actualizan tras la generación de las facturas de servicios públicos.',
    CARBONTOOLTIPSUTILITY:
      'Emisión calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior. Los cálculos reales de emisiones de carbono se basan en la factura de servicios públicos proporcionada.',
    CARBONTOOLTIPLIVE:
      'Emisión calculada para la duración seleccionada a partir de los datos reales con respecto a los datos del año anterior del medidor en el sitio. Los cálculos de CO2 en tiempo real se basan en el medidor principal.',
    CARBONTOOLTIPINTRVAL:
      'Emisión calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior. Los cálculos reales de emisiones de carbono se basan en datos de intervalos de los servicios públicos.',
    ELECTRICITYTOOLTIPCONTENT:
      'Ahorro de electricidad calculado para la duración seleccionada a partir de los datos reales con respecto a los datos del año de referencia',
    DATANEEDED1:
      'Datos insuficientes: los datos del Alcance 1 deben actualizarse cada mes.',
    GASTOOLTIPCONTENT:
      'Ahorro de gas calculado para la duración seleccionada a partir de datos reales con respecto a los datos del año de referencia',
    ALLTOOLTIPCONTENT:
      ' Ahorros calculados para la duración seleccionada a partir de los datos reales con respecto a los datos del año de referencia',
    UTILITYVIEWDETAILSTOOLTIP:
      'Uso y costo calculados para la duración seleccionada a partir de datos reales con respecto a los del año anterior. Nota: El consumo y el costo se calculan en función de los meses calendario y no son específicos de los períodos de facturación de servicios públicos.',
    EMAASENERGYUSAGETOOLTIP:
      'Uso calculado para la duración seleccionada a partir de los datos reales con respecto a los datos del año de referencia',
    EMAASENERGYUSAGETOOLTIPPREV:
      'Uso calculado para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior',
    EMAASCONSUMPTIONTOOLTIP:
      'Uso calculado para la duración seleccionada en función de los datos reales comparados con los datos de referencia o del año anterior',
    EMAASWATEROVERVIEWTOOLTIP:
      'Uso calculado para la duración seleccionada basado en los datos reales comparados con los datos del año anterior',
    EMAASNILMTOOLTIP:
      'Determine el desglose del consumo de energía de su sitio por tipo de equipo',
    PORTFOLIOSUMMARYTOTALSAVINGSTOOLTIP:
      'Ahorro total de costos de los servicios públicos de energía durante el período seleccionado',
    PORTFOLIOSUMMARYEUITOOLTIP:
      'EUI es un indicador de la eficiencia energética del diseño y/o funcionamiento de un edificio. La EUI se mide como la agregación energética de la cartera dividida por los m² totales de la cartera en un año.',
    SITESUMMARYEUITOOLTIP:
      'EUI es un indicador de la eficiencia energética del diseño y/o funcionamiento de un edificio. La EUI se mide como la agregación energética del sitio durante los últimos 12 meses dividida por el área bruta total del sitio.',
    PORTFOLIOSUMMARYEUITOOLTIPHEADER: 'EUI (intensidad de uso de energía)',
    SUMMARYEUITOOLTIPHEADERFORSITE:
      'EUI (intensidad de uso de energía): {date}',
    PROVIDERLISTPLACEHOLDER: 'Buscar detalles del proveedor',
    PORTFOLIOSUMMARYHEADER: 'Descripción general de carbono y energía',
    PORTFOLIOSUMMARYHEADERLASTUPDATEDON: 'Última actualización: {date}',
    AIModelDetails: 'Detalles del modelo de IA',
    DATAUPLOAD: 'Carga de datos',
    ADDFUEL: 'Añadir combustible',
    ADD: 'Añadir',
    ADDCOMPOUND: 'Añadir compuesto',
    ADDMETEREDGAS: 'Añadir gas medido',
    ADDSCOPETWO: 'Añadir alcance 2',
    EXCEEDEDLIMIT: 'se ha superado el límite máximo de 4',
    DETAILS: 'Detalles',
    DATAUPLOADDETAILS:
      'Acceda a todas las funciones que requieren la entrada/carga manual de archivos de datos',
    DATAUPLOADCECARDSUBTITLE:
      'Realice un seguimiento del uso de las emisiones de carbono de alcance 1 para cumplir con los objetivos de desempeño de sostenibilidad de su empresa.',
    DATAUPLOADCARBONESUBTITLE:
      'Esta página presenta una tabla completa que muestra varios combustibles, sus cantidades correspondientes y los factores de emisión de carbono asociados para el año seleccionado.',
    SCOPEONETWOSUBTITLE:
      'Esta página presenta una tabla detallada que muestra las emisiones de Alcance 1 (emisiones directas, incluyendo combustión estacionaria y refrigerantes) y Alcance 2 (emisiones indirectas de electricidad), junto con sus cantidades y factores de emisión de carbono asociados para el año elegido.',
    METERDATASUBHEADER:
      'Acceda a todos sus archivos de datos cargados para obtener datos del medidor.',
    DATAMISSINGALERTS: 'Alertas para datos faltantes',
    UPLOAD: 'Carga masiva',
    UPLOADTOPADD: 'Subir archivo',
    PUBLISHFILE: 'Publicar',
    BASELINEFILE: 'Referencia',
    BASELINE_SUCCESS: 'Capacitación de referencia iniciada correctamente',
    UPLOADTOP: 'Cargar',
    UPLOADFILE: 'SUBIR',
    NAME: 'Nombre',
    DATATYPE: 'Tipo de datos',
    CREATEDON: 'Creado el',
    DATEOFUPLOAD: 'Fecha de carga',
    ALLUPLOADS: 'Todas las cargas',
    STATIONARYCOMBUSTION: 'Combustión estacionaria',
    REFRIGERANTS: 'Refrigerantes',
    WHEATHERDATA: 'Datos meteorológicos',
    UTILITYBILL: 'Factura de servicios públicos',
    SCOPE2: 'Alcance 2',
    METEREDGAS: 'Gas medido',
    NOFILESADDEDHEADER: 'Aún no se añadieron archivos.',
    NOFILESADDEDMESSAGE:
      'Para comenzar, cargue datos meteorológicos, de servicios públicos o de puntos.',
    UPLOADBUTTON: 'Subir',
    METER_DATA: 'Datos del medidor',
    UTILITY_BILL: 'Factura de servicios públicos',
    FUEL_NAME: 'Nombre del combustible',
    SEARCHFOR: 'Buscar',
    EnergyManagementSiteDashboardPortfolioTitle:
      'Panorama del carbono y la energía',
    CHOOSEDATATYPEMESSAGE:
      'Elija el tipo de datos a continuación para descargar la plantilla y continúe con el siguiente paso para cargar los archivos.',
    UPLOADMETERDATASTEPONEMESSAGE:
      'Paso 1: Descargue la plantilla de datos del medidor',
    UPLOADMETERDATA: 'Cargar datos del medidor',
    FILEUPLOADNOTE:
      'Nota: Solo se aceptan archivos {type} y cada uno no debe exceder los {size} MB.',
    UPDATEDFILEUPLOADNOTE:
      'Nota: Solo se aceptan archivos CSV y el archivo no debe superar los 5 Mb.',
    INSTRUCTIONSFORFILLINGTHETEMPLATE:
      'Instrucciones para cargar la plantilla.',
    INSTRUCTIONTEMPLATEONE:
      'Comience cargando datos históricos de lectura de medidores utilizando la plantilla CSV proporcionada.',
    INSTRUCTIONTEMPLATEONEPOINTFIVE:
      'Asegúrese de que los valores de los datos cargados estén en la unidad configurada en RBM para los medidores.',
    INSTRUCTIONTEMPLATEFIVE:
      'El usuario puede cargar un máximo de 10 archivos durante el proceso de carga, con un tamaño de archivo combinado total que no exceda los 1,5 GB.',
    INSTRUCTIONTEMPLATETWO:
      'El usuario puede cargar un máximo de 2 años de datos con intervalos de 1, 3, 5 o 15 minutos y un tamaño de archivo de hasta 1,5 GB.',
    INSTRUCTIONTEMPLATETHREE:
      'Tenga en cuenta que el panel de control y los informes mostrarán los datos históricos del medidor de los últimos 15 días y todos los datos del medidor cargados se utilizarán para entrenar un modelo de referencia de buena calidad.',
    INSTRUCTIONTEMPLATEFOUR:
      'Visualizar un ejemplo de una plantilla CSV completa',
    UPLOAD_PROGRESS_IN_TOAST:
      'El progreso de la carga se puede ver en el widget en la parte inferior de la pantalla.',
    PUBLISHMODALHEADER: '¿Listo para publicar?',
    ERRORINPUBLISHING:
      'Se produjo un error al publicar los archivos. Vuelva a intentarlo en un momento.',
    WARNINGNOTIFICATIONFORPUBLISH:
      'Actualmente se están cargando archivos adicionales',
    WARNINGINSTRUCTIONFORPUBLISHFILE:
      '¿Preferiría esperar antes de publicar o continuar publicando archivos {filesToPublish}?',
    NOTEFORPUBLISHFILE:
      'Nota: Le notificaremos por correo electrónico una vez que se complete la publicación y mostraremos los datos históricos del medidor solo de los últimos 15 días en el panel/informes.',
    INSTRUCTIONFORPUBLISHFILE: '¿Desea publicar los archivos cargados?',
    DOWNLOAD_METER_DATA_CSV_TEMPLATE: 'Download Meter Data CSV Template',
    PUBLISHBUTTON: 'Sí, publicar',
    METERDATAPUBLISHINGMSG:
      'Por favor espere mientras publicamos los datos y le notificaremos por correo electrónico una vez que estén completos.',
    METERDATAUPLOADFAILED:
      'Error en la carga del archivo: {fileName}. Vuelva a intentarlo en un momento.',
    METERDATAUPLOADSUCCESS: 'Archivo: {fileName} cargado correctamente',
    NOBUTTON: 'No',
    METERUPLOADINSTRUCTIONTITLE: 'Instrucciones para cargar datos del medidor',
    METERUPLOADDOWNLOADCSV: 'Descargar la plantilla CSV',
    METERUPLOADDOWNLOADEXCEL: ' Descargar la plantilla CSV',
    METERUPLOADINSTRUCTIONONE:
      'Comience cargando datos históricos de lectura de medidores utilizando la plantilla CSV proporcionada. ',
    METERUPLOADINSTRUCTIONFOUR:
      'Asegúrese de que los datos descargados del supervisor no superen los 1,5 GB. Consulte la información proporcionada para conocer las preferencias de tamaño de datos. ',
    METERDATAEXCELDOWNLOAD: 'Descargar Excel de estimación',
    METERUPLOADINSTRUCTIONTWO:
      'Después de cargar archivos CSV para todos los medidores del sitio o los deseados, haga clic en el botón “Publicar” para procesar y completar los datos históricos.',
    METERUPLOADINSTRUCTIONTHREE:
      'Para establecer una línea de base, haga clic en la "Acción de línea de base" y especifique el rango de datos deseado, y Forge AI entrenará la línea de base utilizando los datos históricos disponibles publicados.',
    CHOOSEDATATYPE: 'Elija el tipo de datos',
    NEXTUPLOAD: 'Próxima carga',
    UPLOADDATA: 'Subir datos',
    ADDNEWFUEL: 'Añadir nuevo combustible a',
    ADDNEWCOMPOUND: 'Añadir nuevo compuesto a',
    MANUALINPUT: 'ENTRADA MANUAL',
    UPLOADDATACAPS: 'SUBIR DATOS',
    ADDNEWFUELSUB:
      'Elija entre las siguientes opciones para ingresar datos o cargar una plantilla manualmente.',
    SCOPEONESC: 'Combustión estacionaria: añadir combustible',
    SCOEONEREF: 'Refrigerantes: Añadir compuesto',
    SCOPETWO: 'Alcance 2',
    UPLOADING: 'Subiendo',
    FILES: 'archivos',
    FILE: 'archivo',
    UPLOADINGMESSAGE1:
      'El progreso de carga y la información del estado de estos archivos son visibles en la notificación emergente ubicada en la parte inferior central de la pantalla.',
    REDIRECTMESSAGE1: 'Será redirigido en',
    REDIRECTMESSAGE1OCR: 'Será redirigido en un momento.',
    REDIRECTMESSAGE2: 's',
    UPLOADFILES: 'Subir archivos para',
    UPLOADMETERDATASTEPTWOMESSAGE:
      'Paso 2: Cargar archivos para los datos del medidor',
    UPLOADNOTE:
      'Solo se aceptan archivos {type} y cada uno no debe exceder los {size} MB',
    UPDATEDUPLOADNOTE:
      'Se acepta solo un archivo CSV y el archivo no debe superar los 1,5 GB.',
    UPDATEDUPLOADNOTESUB: '(solo es posible una carga a la vez)',
    INSTRUCTIONBUTTON: 'ejemplo de una plantilla CSV completa',
    FILEUPLOADPLACEHOLDER: 'Arrastre y suelte archivos aquí',
    SINGLEFILEUPLOADPLACEHOLDER: 'Arrastre y suelte el archivo aquí',
    TOTALSIZEEXCEEDSERROR: 'El tamaño total excede el límite (1,5 GB)',
    NUMBEROFFILEALLOWED: 'Puede subir hasta 10 archivos.',
    FILEUPLOADPLACEHOLDERONLYONEFILE: '(solo es posible una carga a la vez)',
    REMOVE: 'Eliminar',
    CHOOSESERVICE: 'Elija el servicio',
    CONNECT: 'Conectar',
    NEXT: 'Siguiente',
    CHOOSEUTILITYTYPE:
      'Seleccione el proveedor de servicios públicos, las credenciales y los detalles de la cuenta para integrar los datos.',
    CHOOSEUTILITYTYPEMANUAL:
      'Ingrese el proveedor de servicios públicos y los detalles de la cuenta para cargar datos de servicios públicos manualmente.',
    EDITDETAILNOTE:
      'Ingrese los detalles correctos de la cuenta y del medidor a continuación. Luego, haga clic en “Enviar” para actualizarlos y guardarlos.',
    EDITDETAILWHENBILLEXISTS:
      'Ingrese los detalles correctos de la cuenta y del medidor a continuación. Luego, haga clic en “Enviar” para actualizarlos y guardarlos.',
    SEARCHPROVIDER: 'Buscar proveedor de servicios públicos',
    CONTACTSUPPORT:
      '¿No puede encontrar el proveedor de servicios públicos? Póngase en contacto con el equipo de asistencia de Honeywell.',
    UTILITYPROVIDERLABEL: 'Proveedor de servicios públicos',
    SERVICEPROVIDERNAME: 'PROVEEDOR DE SERVICIOS',
    INTEGRATIONTYPENAME: 'TIPO DE INTEGRACIÓN',
    UTILITYSERVICES: 'Servicios públicos',
    UtilityHandoffNotification:
      'El tipo de integración de la cuenta de servicio público {manualCount} se puede convertir de “Manual” a “Automatizada”. Esto permitirá la actualización automática de facturas de servicios públicos sin necesidad de que usted realice ninguna acción. Busque la opción en el menú “Acciones” en la siguiente tabla.',
    UTILITYSERVICESDETAILS:
      'Integre y administre sus múltiples servicios para acceder a los datos de forma automática, rápida e inteligente.',
    ADDUTILITYSERVICE: 'Añadir servicio público',
    ADDUTILITYTYPE: 'Tipo de integración de servicios públicos',
    AUTOMATEDTEXT:
      'Proporcione sus credenciales para la cuenta "Proveedor de servicios públicos" para permitir la recuperación mensual automática de los datos de su factura de servicios públicos.',
    MANUALTEXT:
      'Si no tiene credenciales para su proveedor de servicios y necesita actualizar manualmente la información de la factura de servicios públicos todos los meses, deberá hacerlo manualmente.',
    MANUAL: 'Manual',
    AUTOMATED: 'Automatizado',
    ADD_UTILITY_SERVICE: 'Añadir servicio público',
    UTILITYTYPES: 'TIPOS DE SERVICIO PÚBLICO',
    NOACCOUNTADDEDHEADER:
      'Aún no se han añadido cuentas de servicios públicos.',
    NOACCOUNTADDEDMESSAGE:
      'Comience integrando cuentas para administrar facturas y tarifas',
    ADDACCOUNTNUMBER: 'Añadir',
    SELECTUTILITY: 'Seleccionar un servicio público',
    ACCNUMBER: 'Número de cuenta*',
    UTILITYPROVIDERERROR:
      'Proveedor de servicios públicos no encontrado. Comuníquese con su gerente de Honeywell para obtener ayuda para convertir esta cuenta.',
    PASSWORD: 'Contraseña*',
    USERNAME: 'Nombre de usuario*',
    SIGNIN: 'Iniciar sesión',
    UTILITYPROVIDERTOOLTIPTXT:
      'Ingrese el nombre del proveedor de servicios públicos como se menciona en la factura de servicios públicos.',
    VERIFICATIONINPROCESS: 'Verificación en proceso',
    VERIFICATIONMSSG1:
      'El proceso de verificación de la cuenta tarda 2/3 días.',
    UPDATECREDENTIALS: 'Actualizar credenciales',
    UPDATECREDENTIALSNOTE:
      'Ingrese su contraseña actualizada para "Nombre del proveedor de servicios" a fin de activar su cuenta.',
    ENTERCREDENTIALS: 'Ingresar credenciales',
    ENTERCREDENTIALSNOTE:
      'Utilice sus credenciales para "Nombre del proveedor de servicios" a fin de vincular la cuenta.',
    PLEASEUSESERVICE:
      'Utilice sus credenciales para "Proveedor de servicios" a fin de vincular la cuenta.',
    FILEEMPTYERRORMSG: 'Error. El archivo está vacío. Cárguelo de nuevo.',
    FILESIZEERRORMSG:
      'El tamaño del archivo supera los 50 MB. Reduzca el tamaño del archivo y vuelva a intentarlo.',
    FILEMAXSIZEERRORMSG:
      'El tamaño del archivo excede {maxSize}. Reduzca el tamaño del archivo y vuelva a intentarlo.',
    FILEHEADERERROR:
      'El archivo tiene encabezados no válidos. Utilice la plantilla proporcionada y cárguela nuevamente.',
    CSVFILEINVALID:
      'El nombre o los datos del archivo CSV no son válidos. Verifique el archivo y vuelva a intentarlo.',
    CSVFILEINVALIDNAME:
      'El archivo CSV subido no es válido. No se permite ningún carácter especial ni extensión múltiple.',
    DEACTIVATEACCOUNT: 'Desactivar cuenta',
    DEACTIVATEUDSACCOUNT: 'Desactivar servicio de datos mensuales',
    DEACTIVATEIDSACCOUNT: 'Desactivar IDS (Interval Data Service)',
    REACTIVATEACCOUNT: 'Reactivar cuenta',
    REACTIVATEIDSACCOUNT: 'Reactivar servicio de datos mensuales',
    CONVERTTOAUTOMATIC: 'Convertir a “Automático”',
    MANAGEBILLDETAILS: 'Administrar detalles de la factura',
    MANAGETARIFFDETAILS: 'Administrar tarifas',
    EDITACCOUNTDETAILS: 'Editar detalles de la cuenta',
    EDIT_ACCOUNT_DETAILS: 'Editar detalles de la cuenta',
    ADD_METER: 'Añadir medidor',
    UTILITY_TYPES: 'TIPOS DE SERVICIO PÚBLICO',
    CONVERT_INTEGRATION_TYPE: 'Convertir tipo de integración',
    ACCOUNT_NUMBER: 'Número de cuenta',
    BILLING_CYCLE: 'Ciclo de facturación',
    PERIOD: 'Período',
    EDITACCOUNTDETAILSTOOLTIP:
      'El usuario puede editar todos los campos en caso de que no haya facturas cargadas.',
    EDITACCOUNTDETAILSTOOLTIPFORAUTOMATIC:
      'El usuario puede editar el número de cuenta.',
    CONVERTINTRGRATIONTYPE: 'Convertir a “Automático”',
    ENABLEIDS: 'Enable IDS (Interval Data Service)',
    DELETE: 'Borrar',
    DELETING: 'Borrando',
    DEACTIVATECONFIRMATIONNOTE:
      '¿Está seguro de que desea desactivar el número de cuenta?',
    DEACTIVATEIDSCONFIRMATIONNOTE:
      '¿Está seguro de que desea desactivar IDS (Interval Data Service) para el número de cuenta',
    REACTIVATECONFIRMATIONNOTE:
      '¿Está seguro de que desea volver a activar el número de cuenta?',
    REACTIVATEIDSCONFIRMATIONNOTE:
      '¿Está seguro de que desea volver a activar el servicio de datos de intervalo (IDS) para el número de cuenta?',
    DEACTIVATEUTILITYACCOUNTMSSG:
      'Una vez que se desactive la cuenta, la aplicación no obtendrá automáticamente la información de la factura de servicios públicos y solo se almacenará la información histórica.',
    DEACTIVATEIDSACCOUNTMSSG:
      'Una vez que se desactive el servicio de datos de intervalo (IDS), la aplicación no obtendrá automáticamente los datos de intervalo de servicios públicos y solo se almacenarán los datos históricos.',
    REACTIVATEUTILITYACCOUNTMSSG:
      'Una vez que se reactive la cuenta, la aplicación obtendrá automáticamente la información de la factura de servicios públicos.',
    REACTIVATEIDSUTILITYACCOUNTMSSG:
      'Una vez que se reactive el servicio de datos de intervalo (IDS), la aplicación obtendrá automáticamente los datos de intervalo de servicios públicos.',
    YES: 'Sí',
    NO: 'No',
    REVERIFYNOTE:
      'Ingrese sus credenciales para "Proveedor de servicios" a fin de vincular la cuenta.',
    REVERIFYHEADER: 'Verificar credenciales y número de cuenta',
    REVERIFY: 'Volver a verificar',
    UPDATE: 'Actualizar',
    REENROLL: 'Reactivar cuenta',
    save: 'GUARDAR',
    ACCOUNTMISSINGHEADER: 'Actualizar número de cuenta',
    ACCOUNTMISSINGNOTE:
      'Ingrese sus credenciales para "Proveedor de servicios" y el número de cuenta a fin de vincular la cuenta.',
    SHOWMORE: 'Mostrar más',
    NORESULTS: 'Sin resultados.',
    BREAKDOWNBYSITE: 'Desglose por sitio ({count})',
    PORTFOLIOENERGY: 'Energía',
    PORTFOLIOENERGYCONS: 'Consumo de energía',
    PORTFOLIOCONSUMTION: 'Consumo',
    PORTFOLIOWATER: 'Agua',
    PORTFOLIOWATERCONS: 'Consumo de agua',
    ENERGYUSAGEBYSITE: 'Uso de energía por sitios ({count})',
    SITEWITHDATA: '* Solo se muestran los sitios con datos en la tabla',
    ELECTRICITYUSAGEBYSITE: 'Consumo de electricidad por sitios ({count})',
    GASUSAGEBYSITE: 'Consumo de gas por sitios ({count})',
    WATERUSAGEBYSITE: 'Uso de agua por sitios ({count})',
    ENERGYOPTIMIZATION: 'Optimización inteligente de edificios',
    ENERGYOPTIMIZATIONNEW: 'Energy Optimization',
    ENERGYOPTIMIZATIONEO: 'Energy Optimization (EO)',
    ENERGYOPTIMIZATIONSAVINGS: 'Ahorros de EO',
    EOSETTINGSUBTITLE:
      'La EO monitorea, mide y optimiza continuamente los sistemas de HVAC en edificios para lograr el menor consumo de energía en todas las situaciones, lo que minimiza la energía consumida en calefacción y refrigeración de una instalación.',
    EOSETTINGMODALHEADER: '¿Desea desactivar la optimización de energía?',
    EOSETINGMODALCONTENT:
      'La optimización inteligente de edificios no monitoreará, medirá ni optimizará continuamente el HVAC en sus instalaciones para lograr el menor consumo de energía.',
    EOSETINGMODALCONTENTSUB:
      '¿Estás seguro de que deseas desactivar la optimización energética?',
    EOENABLETITLE: 'Habilite la optimización de energía para este sitio.',
    EOSTATUSMESSAGESUCCESS:
      'La optimización inteligente de edificios se habilitó correctamente para este sitio.',
    EOSTATUSMESSAGEERROR:
      'La optimización inteligente de edificios se deshabilitó correctamente para este sitio.',
    EOSETTINGNODATAAVAILABLE:
      'Por favor contacte al administrador del sistema, la configuración no está completa.',
    CURRENTEOSTATUS: 'Estado actual de la EO: ',
    ON: 'Encendido',
    OFFMANUALSWITCHEDOFF: 'Apagado: desconexión manual',
    OFFLINE: 'Fuera de línea',
    EONotOptimizing: 'EO no está optimizando',
    OFFPLANNEDOFFFORIMPROVINGBASELINE:
      'Apagado: planificado para mejorar la referencia',
    SwitchedOfffromCloud: 'Desactivado desde la nube',
    SwitchedOfffromSite: 'Desactivado desde el sitio',
    EOON: 'El estado EO On indica la estrategia de optimización actual en uso',
    EOMANUALSWITHCHEDOFF:
      'el punto de ajuste no se ha aplicado desde que se apagó manualmente la EO',
    PLANNEDOFFFORBASELINE:
      'Se planea desactivar la EO para mejorar la referencia.',
    STATUSNOTAVAILABLE: 'Estado no disponible',
    STATUSNOTAVAILABLETOOLTIP:
      'Los detalles del estado no están disponibles en este momento. Comuníquese con el equipo de soporte de Honeywell -connectedbuildingsupport@honeywell.com para resolver esta condición',
    EOOFFLINE:
      'El estado apagado de EO indica que la estrategia de optimización no está en uso debido a un fallo en la optimización.',
    SwitchedOfffromCloudToolTip:
      'EO está apagado manualmente desde la nube. Comuníquese con el soporte de edificios conectados para encender la EO -connectedbuildingsupport@honeywell.com',
    SwitchedOfffromSiiteToolTip:
      'EO está apagado manualmente por el usuario desde el sitio',
    EOSavings: ' Ahorros de la optimización inteligente de edificios',
    EOUtility_all: 'Todos los servicios públicos',
    EOUtility_electricity: 'Electricidad',
    EOUtility_gas: 'Gas',
    EOUtility_steam: 'Vapor',
    EOUtility_chilledwater: 'Agua helada',
    EOUtility_hotwater: 'Agua caliente',
    inactiveDays: 'Días de inactividad',
    inactiveDay: 'Día de inactividad',
    excludedDays: 'Días excluidos',
    excludedDay: 'Día excluido',
    activeHours: 'Horas activas',
    activeDay: 'Día activo',
    savingsSummaryEO:
      'Ahorros estimados (con {opertionalPercentage} % de tiempo operativo de EO)',
    operationalTimeEO: 'Con {opertionalPercentage}% de tiempo operativo de EO',
    timeUsedForBaselining:
      '{baseline}% del tiempo utilizado para la referencia',
    siteComfort: 'Comodidad del sitio',
    activeStrategyStatus: 'Activo',
    inactiveStrategyStatus: 'Inactivo',
    lastUpdated: 'Última actualización:',
    CALCULATED: 'Referencia',
    ESTIMATEDSAVINGS: 'Ahorros estimados',
    OPPORTUNITYFROMEO: 'Oportunidad de EO',
    EMAASEOSTATETOOLTIP:
      'El estado activo o inactivo indica la estrategia de optimización actual en uso.',
    EOSAVINGTOOLTIP:
      'Ahorro de energía cuando se ejecutó la optimización inteligente de edificios en comparación con el uso de energía calculado.',
    EOSAVINGONENABLE: 'Ahorros en días habilitados para la IBO',
    EOSAVINGENTIREPERIOD: 'Ahorros durante todo el período',
    EONEGATIVEORZEROSAVINGSMESSAGE:
      'No hay ahorros dentro del rango de tiempo seleccionado. Para conocer el ahorro estimado, considere ampliar la duración seleccionada a un período más largo.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIP:
      'El consumo calculado para la duración seleccionada a partir de datos reales con respecto a los datos del año de referencia. La EUI se calcula utilizando los datos de energía de las facturas de servicios públicos.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIPPREV:
      'El consumo calculado para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior. La EUI se calcula utilizando los datos de energía de las facturas de servicios públicos.',
    EMAASPORTFOLIOCONSUMPTIONTOOLTIP:
      'Uso calculado para la duración seleccionada basado en los datos reales comparados con los datos de referencia o del año anterior. La EUI se calcula utilizando los datos de energía de las facturas de servicios públicos.',
    CEMSPORTFOLIO_UTIL_LIVE_CONSUMP_TOOLTIP:
      'El uso se calcula para el período seleccionado a partir de datos reales, en comparación con datos anteriores o de referencia para las facturas de servicios públicos y del medidor en tiempo real respectivamente. El uso mensual se basa en el promedio diario de energía proveniente de las facturas de servicios públicos, normalizado para meses completos cuando abarca dos meses.',
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_TOOLTIP:
      'El uso se calcula para el período seleccionado a partir de los datos reales, en comparación con los datos de referencia del medidor en el sitio.',
    CEMSPORTFOLIO_DATA_SOURCE_INTERVAL_TOOLTIP:
      'El uso se calcula para el período seleccionado a partir de los datos reales, en comparación con los datos de referencia de los datos de intervalo de servicios públicos.',
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_WATER_TOOLTIP:
      'El uso se calcula para el período seleccionado a partir de los datos reales, en comparación con los datos anteriores del medidor en el sitio.',
    CEMSPORTFOLIO_DATA_SOURCE_UTIL_TOOLTIP:
      'El uso se calcula para el período seleccionado a partir de los datos reales, en comparación con los datos del período anterior de las facturas de servicios públicos. El uso mensual se basa en la energía diaria promedio de las facturas de servicios públicos, normalizada para el mes completo cuando la factura abarca dos meses.',
    PORTFOLIOEUI: 'EUI ({unit})',
    PORTFOLIOWATERChange: 'Cambio',
    PORTFOLIOSITECOUNT: 'Desglose por sitio ({count})',
    UTILITYCOSTBYSITES: 'Costo de {Utility} por sitios ({count})',
    ALLUTILITYCOSTBYSITES: 'Costo del servicio por sitios ({count})',
    SOLAR: 'Solar',
    WIND: 'Viento',
    SOLARPERFORMANCE: 'Rendimiento solar',
    WINDPERFORMANCE: 'Rendimiento eólico',
    UTILITYCOSTOVERVIEW:
      'Descripción general del costo de los servicios públicos',
    DESCRIPTIONNOTIFICATION:
      'Ha alcanzado el número máximo de cuentas de servicios públicos para el mismo tipo de servicio. Póngase en contacto con su administrador para crear más cuentas.',
    TITLENOTIFICATION: 'Se alcanzó el límite de cuentas.',
    ENERGYUSAGECAPS: 'USO DE ENERGÍA',
    UPDATEERRORMESSAGE: 'Se produjo un problema. Intente nuevamente más tarde.',
    MANUALTOAUTOMATICCONVERSION:
      'La conversión de la cuenta de Manual a Automática se inició correctamente.',
    APPLY: 'APLICAR',
    RESET: 'RESTABLECER',
    CLOSE: 'CERRAR',
    SCOPE1FUELTYPES: 'Tipos de combustible de Alcance 1',
    SCOPE1FILTERSUBHEADER: 'El filtro solo cambia la vista gráfica',
    SCOPE1DATAMISSING: 'Faltan datos de Alcance 1',
    SCOPE1SHOWMISSINGDATA:
      'Revise los datos faltantes del Alcance 1 y actualícelos.',
    FUELGASTYPE: 'Tipo de combustible/gas',
    COMPOUNDTYPE: 'Tipo de compuesto',
    UTILITYTYPE: 'Tipo de servicio público',
    FUELGASTYPESELECT: 'Seleccione un tipo de combustible/gas',
    COMPOUNDSELECT: 'Seleccionar tipo de compuesto',
    UTILITYSELECT: 'Seleccionar el tipo de servicio público',
    EMISSIONFACTOR: 'Factor de emisión de CO2',
    SelectCategory: 'Seleccionar categoría',
    UNIT: 'Unidad',
    UNITSELECT: 'Seleccionar una unidad',
    StationaryCombustion: 'Combustión estacionaria',
    YEAR: 'Año',
    Country: 'País',
    State: 'Estado',
    YEARSELECT: 'Seleccione un año',
    MONTH: 'Mes',
    Override: 'Anulación',
    MONTHSELECT: 'Seleccionar un mes',
    ADDDATA: 'Añadir datos',
    NOFUELCONSUMED: 'Sin consumo de combustible ',
    NOCONSUMED: 'Sin consumo',
    QUANTITY: 'Cantidad',
    QUANTITYENTER: 'Ingresar la cantidad',
    COSTSCOPE: 'Costo',
    COSTENTER: 'Ingresar costo',
    EDIT: 'Editar',
    YEARCHECK: 'año',
    MONTHERROR: 'Seleccionar un mes diferente',
    SUCCESS: 'Los datos se actualizaron con éxito',
    CO2FACTORROOLTIPHEADER: 'Factor de emisión de CO2',
    PLEASENOTE: 'Tener en cuenta: ',
    PLEASENOTETEXT:
      'El nuevo factor de emisiones de carbono se utilizará en el próximo cálculo de emisiones de carbono. Los valores de emisiones de carbono ya calculados no se volverán a calcular utilizando el nuevo valor.',
    CO2FACTORROOLTIPCONTENT:
      'Es la cantidad de CO2 liberada a la atmósfera por unidad de energía utilizada',
    CO2FACTORSCCONTENT:
      'Es la cantidad de CO2 liberada a la atmósfera por unidad de energía utilizada. Ingrese el valor equivalente en kgCo2e/mmbtu para la unidad seleccionada.',
    CO2FACTORRFCONTENT:
      'Es la cantidad de CO2 liberada a la atmósfera por unidad de energía utilizada. Ingrese el valor equivalente en MTCo2e/mmbtu para la unidad seleccionada.',
    CO2FACTORSCOPETWOANDGASCONTENT:
      'Es la cantidad de CO2 liberada a la atmósfera por unidad de energía utilizada. Ingrese el valor equivalente para la unidad seleccionada.',
    FUELTABLETEXT:
      'Los siguientes tipos de combustible pertenecen a las emisiones de Alcance 1',
    METEREDGASHEADER:
      'Los siguientes tipos de servicios públicos pertenecen a las emisiones de Alcance 1',
    SCOPETWOHEADER:
      'Los siguientes tipos de servicios públicos pertenecen a las emisiones de Alcance 2',
    UNITDROPDOWNNAME: 'Unidad',
    COMPOUNDTABLETEXT:
      'Los siguientes tipos de compuestos pertenecen a las emisiones de Alcance 1',
    ENERGYCONSUMPTIONNILM: 'Consumo de energía',
    ENERGYCONSUMPTIONSECONDHEADERNILM:
      'El gráfico muestra el consumo de energía y su desglose durante el período seleccionado.',
    ENERGYCONSUMPTIONBYEQUIPMENTTYPE: 'Consumo de energía por tipo de equipo',
    METERNAME: 'Nombre del medidor*',
    METERNUMBER: 'Número de medidor*',
    CONSUMPTIONUNIT: 'Unidad de consumo',
    DEMANDUNIT: 'Unidad de demanda',
    CURRENCYUNIT: 'Unidad monetaria',
    TOTALMETERS: 'TOTAL DE MEDIDORES',
    METERNAMECHANGEDESCRIPTION:
      'A continuación se muestra la lista de identificaciones de medidores asociados con la cuenta.',
    METERNAMEUPDATESUCCESS:
      'ID del medidor: ({meterId}) ha cambiado de nombre exitosamente a "({meterName})"',
    METERNAMECHARACTERS: 'Utilice únicamente caracteres alfanuméricos',
    METERNAMEMAXLENGTH: 'Longitud máxima: {maxCh} caracteres',
    NILMDROPDOWNALLMETERS: '',
    BILLBREAKDOWN_OVERVIEW: 'Resumen de consumo ({rate})',
    DEMAND_OVERVIEW: 'Resumen de la demanda {rate}',
    DEMAND: 'Demanda',
    CONSUMPTION_RATE_OVERVIEW: '{name} Descripción general ({rate})',
    ELECTRICITYBLENDEDRATE: 'Tarifa de electricidad combinada ({rate})',
    BILLBREAKDOWN_COST_OVERVIEW: '{utilityName} Resumen de costos ({rate})',
    BILLBREAKDOWN_COST_TOOLTIP_HEADER: 'Costo de electricidad ({rate})',
    COST: 'Resumen de consumo',
    SUMMARY: 'Resumen',
    PDF: 'PDF',
    MANAGE_COLUMNS: 'Administrar columnas',
    RESET_ALL_FILTERS: 'Restablecer todos los filtros',
    DOWNLOAD_CSV: 'Descargar CSV',
    DOWNLOAD_PDF: 'Ver y descargar PDF',
    UTILITY_BILL_ANALYSIS: 'Análisis de la factura de {utilityName}',
    NOTIFICATIONBOXFORMONTHLY:
      'El análisis de facturas de electricidad viene con vistas mensuales y de período de facturación.  La vista mensual calcula la factura de servicios públicos desde el principio hasta el final del mes en prorrata. Ejemplo (01 de mayo de 2022 - 31 de mayo de 2022). Mientras que la vista del período de facturación calcula la factura de servicios públicos según el ciclo de facturación real. Ejemplo (22 de mayo de 2022 al 22 de junio de 2022). Haga clic en el período de facturación para ver los datos según el ciclo de facturación real.',
    SUMMARYTABLEAPIONGOING:
      'Las llamadas a la tabla de resumen se están procesando por lotes, haga clic una vez que se hayan cargado todos los datos de la tabla.',
    NOTIFICATIONFORBILLINGPERIOD:
      'La vista del período de facturación calcula la factura de servicios públicos según el ciclo de facturación real. Ejemplo (22 de mayo de 2022 al 22 de junio de 2022).',
    VIEW_OVERVIEW: 'Ver descripción general',
    FILE_DELETED_SUCCESSFULLY: 'Archivo eliminado exitosamente',
    FILE_DELETEING_ERROR:
      'Error al eliminar el archivo. Vuelva a intentarlo en un momento.',
    AVG_CONSUMP_PER_MTH: 'Consumo medio mensual',
    AVG_CONSUMP_PER_DAY: 'Consumo medio por día',
    MTHLY_CONSUMP_PER_SQFT: 'Consumo mensual por pie cuadrado.',
    EnableIDSText:
      'Ingrese las credenciales para verificar la cuenta. Haga clic en Enviar para habilitar IDS.',
    EnableIDSHeaderTxt: 'Habilitar IDS (Servicio de datos de intervalo)',
    EOSAVINGS: 'Ahorros de EO',
    EOSUMMARY: 'Resumen de EO',
    REASONFOROFFLINE: 'Reason for Off - Details'
  },
  alarmConfiguration: {
    ALARMTYPE: 'Tipo de alarma',
    CONFIGUREALARMDESCLINE1:
      'Seleccione el tipo de alarma para los medidores que se configurarán',
    CONFIGUREALARMDESCLINE2:
      'Seleccione el tipo de alarma para que los medidores emitan alarmas en caso de que el consumo de energía supere el valor de referencia en el rango mencionado.',
    ALLMETERS: 'Todos los medidores ',
    SEARCHALARMTYPE: 'Seleccionar el tipo de alarma',
    SEARCHMETERS: 'Buscar medidor',
    THRESHOLDSETTINGS: 'AJUSTES DE UMBRAL',
    NOMETERSSELECTED:
      'Seleccione al menos uno o más medidores a la izquierda\nPanel para cambiar valores de umbral.',
    THRESHOLDALARM: 'ALARMA DE UMBRAL',
    ALARMNAME: 'Nombre de la alarma',
    MINTHRESHOLD: 'Umbral mínimo',
    MAXTHRESHOLD: 'Umbral máximo',
    TO: 'hasta',
    RESETTODEFAULTS: 'Restablecer a valores predeterminados',
    SAVE: 'GUARDAR',
    NOMETERSUNDERSITE: 'Sin medidores disponibles',
    NOSITESAVAILABLE: 'Sin sitios disponibles',
    VALIDATIONREQUIRED:
      'Se debe seleccionar al menos una prioridad y se deben completar todas las entradas bajo ella.',
    VALIDATIONOVERLAPPING:
      'Los datos ingresados no son válidos o se superponen con otros valores'
  },
  urjanetStatus: {
    ENROLLED: 'Registro exitoso',
    ENROLLEDMSG: 'Se extrajo la cuenta correctamente.',
    SUCCESSFUL_DELIVERED: 'Entregado correctamente',
    SUCCESSFUL_DELIVEREDMSG: 'Se extrajo y se entregó la cuenta correctamente.',
    PRODUCTION: 'Producción',
    PRODUCTIONMSG: 'La cuenta está en producción',
    Active: 'Activo',
    ACTIVEMSG:
      'Existe una cuenta de entrada manual y el usuario puede ingresar facturas manualmente.',
    Enroll_Successful: 'Inscripción_Exitosa',
    FAILEDLOGIN: 'Error de inicio de sesión',
    NEEDSCREDENTIAL: 'Necesita Credencial',
    NEEDSCREDENTIALMSG: 'La cuenta no tiene una credencial asociada',
    FAILEDTOACCESS: 'Error al acceder.',
    NEEDSTEMPLATE: 'Se necesita plantilla.',
    NEEDSTEMPLATEMSG:
      'La cuenta tiene una credencial, pero esa credencial no tiene una plantilla asignada',
    UNDERREVIEW: 'Bajo revisión',
    UNDERREVIEWMSG: 'Error con el estado genérico',
    WEBSITEISSUE: 'Problema con el sitio web',
    WEBSITEISSUEMSG:
      'La cuenta está fallando al intentar conectarse con el sitio web.',
    CAPTCHALOGIN: 'Inicio de sesión Captcha',
    CAPTCHALOGINMSG:
      'El inicio de sesión está bloqueado por Captcha en el sitio web',
    TEMPLATEFAILURE: 'Fallo de plantilla',
    TEMPLATEFAILUREMSG:
      'Un problema con la plantilla impidió una extracción correcta',
    NEEDSENROLLMENT: 'Necesita inscripción',
    NEEDSENROLLMENTMSG: 'La cuenta debe estar registrada',
    NOBILL: 'Sin factura',
    NOBILLMSG: 'La cuenta no tiene ninguna factura disponible en el sitio web.',
    REENROLLED: 'Reinscrito',
    REENROLLEDMSG:
      'La cuenta se inscribe de nuevo después de la desactivación.',
    NAVIGATIONFAILURE: 'Falla de navegación',
    NAVIGATIONFAILUREMSG: 'Se requiere ajuste de plantilla para estas cuentas.',
    SOURCEFORMATCHANGE: 'Cambio de formato de origen',
    SOURCEFORMATCHANGEMSG: 'Se ha detectado un nuevo formato de factura',
    ACCOUNTNUMBERCHANGE: 'Cambio de número de cuenta',
    ACCOUNTNUMBERCHANGEMSG: 'El número de cuenta cambió al nuevo',
    USERACTIONREQUIRED: 'Se requiere acción del usuario',
    USERACTIONREQUIREDMSG: 'Se requiere acción del cliente',
    MIGRATION: 'Migración',
    MIGRATIONMSG: 'Cuenta migrada con nuevo proveedor/número de cuenta',
    INITIALTEMPLATEDEVELOPMENT: 'Desarrollo de plantilla inicial',
    INITIALTEMPLATEDEVELOPMENTMSG: 'La plantilla está en desarrollo.',
    REJECTED: 'Rechazado',
    REJECTEDMSG: 'Cuentas rechazadas porque no son válidas para ser procesadas',
    EBILLENROLLMENT: 'Inscripción a factura electrónica',
    EBILLENROLLMENTMSG:
      'Cuenta para la cual se requiere o está pendiente la inscripción a la factura electrónica',
    CREDENTIALUPDATED: 'Credencial actualizada',
    CREDENTIALUPDATEDMSG:
      'Las credenciales se han actualizado después de fallar, el proceso de verificación de la cuenta demora dos o tres días.',
    TEMPLATEUPDATED: 'Plantilla actualizada',
    TEMPLATEUPDATEDMSG: 'La plantilla se ha actualizado pero no se ha probado.',
    UNKNOWN: 'Desconocido',
    UNKNOWNMSG: 'El estado de la cuenta es desconocido',
    PENDINGMSG: 'El estado de la cuenta está pendiente.',
    PENDING: 'Pendiente',
    DELETED: 'Eliminado',
    DELETEDMSG: 'La cuenta ha sido eliminada',
    ENROLLMENTFAILUREMSG: 'Error en la inscripción de la cuenta',
    ENROLLMENTFAILURE: 'Fallo de inscripción',
    DOESNOTEXIST: 'Does_Not Exist',
    DOESNOTEXISTMSG: 'La cuenta no existe',
    ACCOUNTNUMBERMISMATCHMSG: 'El número de cuenta no coincide',
    ACCOUNTNUMBERMISMATCH: 'Incompatibilidad de número de cuenta',
    CONVERSIONINPROGRESS: 'Conversión en proceso',
    CONVERSIONINPROGRESSMSG:
      'Conversión de cuenta en proceso de manual a automática',
    FAILEDTOACCESSMSG:
      'La extracción no devolvió ningún resultado (podría ser un sitio web nuevo o una navegación defectuosa).',
    FAILEDTOACCESSMSGIDS: 'Failed to access utility interval data',
    FAILEDLOGINMESSAGE:
      'La navegación falló específicamente en el paso de inicio de sesión (comprobar usuario y contraseña).',
    ACCOUNTMISSING: 'Falta la cuenta',
    ACCOUNTMISSINGMESSAGE:
      'La credencial se ejecutó y tuvo éxito parcialmente, pero no quedó rastro de esta cuenta.',
    CONNECTIONERROR: 'Error de conectividad',
    CONNECTIONERRORMESSAGE:
      'Algo salió mal. Vuelva a ingresar las credenciales del “Proveedor de servicios” para la cuenta.',
    CONNECTIONERRORMESSAGEIDS: 'Something went wrong.',
    BLOCKED: 'Cuenta bloqueada',
    BLOCKEDMESSAGE: 'Inicio de sesión bloqueado.',
    INACTIVE: 'Cuenta inactiva',
    INACTIVEMESSAGE: 'La cuenta está inactiva.',
    FINALLED: 'Cuenta cerrada',
    FINALLEDMESSAGE:
      'Revise la cuenta y anule la suscripción de la cuenta si ya no necesita ser procesada.',
    VERIFICATIONINPROG: 'Verificación en curso',
    VERIFICATIONINPROGIDS: 'Activation in progress',
    REENROLLMENTPROG: 'Reinscripción en proceso',
    REACTIVATIONPROG: 'Reactivation in progress',
    SUBMITTED: 'Enviado',
    SUBMITTEDMSG: 'Estado inicial de la cuenta; debe proceder automáticamente',
    NOMINATEDPROG: 'Nominado',
    METERSMISMATCHED: 'Medidores incompatibles',
    METERSMISMATCHEDMSG:
      'Los detalles del medidor no coinciden. Actualícelos en Editar detalles de la cuenta.',
    VERIFICATIONINPROGMESSAGE:
      'El proceso de verificación de la cuenta tarda 2/3 días.',
    VERIFICATIONINPROGMESSAGEIDS:
      'El proceso de verificación de la cuenta tarda 2/3 días.',
    REENROLLMENTTOOLTIP:
      'La acción de reinscripción en esta cuenta se inicia después de la desactivación',
    REACTIVATIONTOOLTIP:
      'La acción de reactivación en esta cuenta de IDS se inicia nuevamente después de la desactivación',
    NOMINATEDMESSAGE:
      'La cuenta tiene una credencial completamente provisionada que aún no se ha ejecutado.',
    DATAUNAVAILABLE: 'Factura fallida',
    STATEMENTMISSING: 'Resumen faltante',
    DATAUNAVAILABLEMESSAGE:
      ' Se extrajo una factura, pero no se conservó debido a fallas de auditoría, fallas de almacenamiento, etc.',
    STATEMENTMISSINGMSG:
      'La credencial se ejecutó y tuvo éxito, y la cuenta se vio en el sitio web, pero no pudimos extraer un resumen.',
    NOTENROLLED: 'Sin inscripción',
    NOTENROLLEDMESSAGE:
      'La extracción de la cuenta fue exitosa, pero la cuenta en cuestión no está suscrita',
    DEACTIVATED: 'Desactivado',
    DEACTIVATEDMESSAGE: 'La cuenta ya no está activa.',
    REVIEWACCOUNTANDUNS:
      'Revise la cuenta y anule la suscripción de la cuenta si ya no necesita ser procesada',
    ERROR: 'Error',
    ERRORMESSAGE: 'Se produjo un problema. Comuníquese con su administrador.',
    LOGINFAILURE: 'Falla de inicio de sesión',
    LOGINFAILUREMESSAGE:
      'El inicio de sesión falló debido al cambio de contraseña o al vencimiento de la cuenta del proveedor de servicios.',
    DEACTIVATIONINITIATEDMSSG: 'Desactivación iniciada.',
    DEACTIVATIONINITIATED: 'Desactivación en curso',
    REENROLLEDREQUIRED: 'Se requiere reinscripción',
    REENROLLEDREQUIREDMSG:
      'Es necesaria la reinscripción en la cuenta. Ingrese nuevamente las credenciales haciendo clic en actualizar.',
    ENABLEIDSMSG:
      'El servicio de datos de intervalo (IDS) se ha habilitado correctamente.',
    INTERVALSNOTSUPPORTED: 'No compatible',
    INTERVALSNOTSUPPORTEDMSG:
      'El servicio de datos de intervalo (IDS) no es compatible con el proveedor de servicios públicos para esta cuenta.',
    PLUGNEWACCOUNTMSG: 'Cuenta inscrita correctamente',
    PLUGEMAILAPPROVALMSG:
      'La verificación de la cuenta está en curso y Arcadia requiere la aprobación por correo electrónico del cliente',
    PLUGCREDENTIALISSUEMSG:
      'Error al acceder a los datos de intervalo de servicios públicos debido a un problema con las credenciales',
    PLUGNODATAAVAILABLEMSG:
      'Error al acceder a los datos de intervalo de servicios públicos debido a que no hay datos disponibles',
    PLUGUNSUCCESSFULEMAILAPPROVALMSG:
      'Error al acceder a los datos de intervalo de servicios públicos debido a que la aprobación por correo electrónico fue fallida',
    PLUGINVALIDCREDENTIALSMSG:
      'Error de conexión debido a credenciales no válidas'
  },
  virtualMeters: {
    SELECTED: 'Medidores de electricidad - Seleccionados ({count})',
    SEARCHMETERS: 'Buscar nombre del medidor',
    METERGROUPDETAILS: 'DETALLES DEL GRUPO DE MEDIDORES',
    METERGROUPNAME: 'Nombre del grupo de medidores',
    DESCRIPTION: 'Descripción',
    DESCRIPTIONPLACEHOLDER: '240 caracteres máx.',
    VALIDATIONREQUIRED:
      'Se deben seleccionar al menos dos medidores y llenar ambas entradas.',
    SAVE: 'GUARDAR',
    CANCEL: 'CANCELAR'
  },
  DetailedView: {
    TOTALEMISSIONS: 'Emisiones totales',
    TOTALEMISSION: 'Emisión total',
    SCOPEONETITLE: 'Emisiones de carbono por Alcance 1',
    SCOPETWOTITLE: 'Emisiones de carbono por Alcance 2',
    SCOPE1: 'Alcance 1',
    SCOPE2: 'Alcance 2',
    SCOPEONEDATANOTCONSIDER: 'Los datos de Alcance 1 necesitan actualizaciones',
    CARBONTITLE: 'Descripción general de emisiones de carbono',
    PORTFOLIOCARBONTITLE: 'Cartera de emisiones de carbono (CO2e)',
    TOTALEMISSIONSTOOLTIP:
      'Emisión calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior.',
    CARBONTOOLTIPSUTILITYDETAIL:
      'Emisión calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior. Los cálculos de emisiones de carbono reales se basan en la factura de servicios públicos proporcionada.',
    CARBONTOOLTIPLIVEDETAIL:
      'Emisión calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior desde el medidor en el sitio. Los cálculos de C02 en tiempo real se basan en el medidor principal.',
    CARBONTOOLTIPINTRVALDETAIL:
      'Emisión calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior. Los cálculos de emisiones de carbono reales se basan en los datos de intervalo de servicios públicos.',
    SCOPEONETOOLTIP:
      'Emisión directa calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior.',
    SCOPETWOTOOLTIP:
      'Emisión indirecta calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior.',
    SCOPEONETOOLTIPUTILITY:
      'Emisión directa calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior. Los cálculos de emisiones de carbono reales se basan en la factura de servicios públicos proporcionada.',
    SCOPEONETOOLTIPINTERVAL:
      'Emisión directa calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior. Los cálculos de emisiones de carbono reales se basan en los datos de intervalo de servicios públicos.',
    SCOPEONETOOLTIPLIVE:
      'Emisión directa calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior desde el medidor en el sitio. Los cálculos de C02 en tiempo real se basan en el medidor principal.',
    SCOPETWOTOOLTIPdUTILITY:
      'Emisión indirecta calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior. Los cálculos de emisiones de carbono reales se basan en la factura de servicios públicos proporcionada.',
    SCOPETWOTOOLTIPINTERVAL:
      'Emisión indirecta calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior. Los cálculos de emisiones de carbono reales se basan en los datos de intervalo de servicios públicos.',
    SCOPETWOTOOLTIPLIVE:
      'Emisión indirecta calculada para la duración seleccionada a partir de datos reales con respecto a los datos del año anterior desde el medidor en el sitio. Los cálculos de C02 en tiempo real se basan en el medidor principal.',
    CARBONDETAILKEY: 'detalle del carbono',
    SCOPEONEKEY: 'detalle del resumen sin moneda',
    UTILITYDETAILKEY: 'detalle del servicio público',
    METER: 'MEDIDOR',
    METERNAME: 'NOMBRE DEL MEDIDOR',
    FUELTYPE: 'TIPO DE COMBUSTIBLE',
    SITES: 'SITIOS',
    SOURCE: 'FUENTE',
    CURRENTAVOIDANCE: 'AHORRO ACTUAL',
    PREVIOUSAVOIDANCE: 'AHORRO ANTERIOR',
    UTILITYTYPE: 'TIPO DE SERVICIO PÚBLICO',
    ACTUALEMISSION: 'EMISIONES REALES',
    ACTUALEMIS: 'EMIS. REALES',
    PREVIOUSEMISSION: 'EMISIONES ANTERIORES',
    PREVIOUSPERIOD: 'EMISIÓN ANTERIOR',
    PREVIOUSEMISSIONS: 'Emisiones anteriores',
    PORTFOLIOPREVIOUSConsumption: 'PERIODO ANTERIOR',
    PORTFOLIOACTUALEMISSION: 'EMISIONES REALES',
    PORTFOLIOPREVIOUSEMISSION: 'EMISIONES ANTERIORES',
    PORTFOLIOPREVIOUSCOST: 'COSTO ANTERIOR',
    CHANGE: 'CAMBIO',
    ACTUALCONS: 'CONS. REAL',
    BASELINECONSP: 'CONS. DE REFERENCIA',
    PREVPERIOD: 'PERÍODO ANT.',
    CHANGEPERCENT: '% CAMBIO',
    EUICURRENT: 'CORRIENTE EUI',
    EUIPRVPERIOD: 'EUI ANT. PERÍODO',
    PORTFOLIOACTUALCOST: 'COSTO REAL',
    SAVINGS: 'AHORRO',
    FuelType: 'Tipo de combustible',
    Emissions: 'EMISIONES',
    CARBONAVOIDANCE: 'Reducción de carbono',
    carbonEmissionsAvoidance: 'Reducción de emisiones de carbono',
    TOTALAVOIDANCETOOLTIP:
      'Reducción de carbono calculada para la duración seleccionada a partir de datos reales respecto de los datos del año anterior.',
    Meters: 'Medidores',
    ActivePower: 'Energía activa',
    ActivePowerContent: 'Potencia instantánea medida en un momento específico.',
    AVGpower: 'Potencia media',
    PeakPower: 'Potencia máxima',
    PeakPowerContent:
      'Demanda máxima de potencia para la selección del rango de fechas.',
    LoadType: 'Tipo de carga',
    LoadTypeContent: 'Tipo de carga a la que está asociado el medidor.',
    FifteenMinuteElectricConsumption: 'Cons. 15 min',
    FifteenMinuteElectricConsumptionPrediction: 'Pred. 15 min',
    ElectricityConsumption: 'Consumo total de energía',
    EnergyConsSelectedPeriod: 'Período seleccionado de consumo de energía',
    EnergyConsToday: 'Consumo de energía hoy',
    EnergyConsTodayContent: 'Consumo total de energía para hoy.',
    EnergyConsMonth: 'Consumo de energía mensual',
    EnergyConsMonthContent: 'Consumo total de energía para el mes actual.',
    TotalEnergyConsumption: 'Consumo total de energía',
    TotalEnergyConsumptionContent: 'Consumo totalizado de los medidores',
    EnergyConsSelectedPeriodContent:
      'Período seleccionado de consumo de energía',
    DataQuality: 'Calidad de los datos',
    BaselineQuality: 'Calidad de referencia',
    PowerDemand: 'Demanda de potencia',
    APPLYBASELINEFROMDATEINVALID:
      'Seleccione una fecha no mayor a 15 días atrás.',
    INVALIDEXCLUSIONRANGESELECTION:
      'Seleccione la fecha de exclusión dentro del rango de fechas de capacitación seleccionado'
  },
  NILM: {
    NILMModalHeader: 'Regístrate en NILM',
    NILMMeterDetails: 'Añadir detalles de NILM',
    SmartXMeter: 'Vista previa',
    NILMDetailsTabHeader:
      'Ingrese los detalles de su medidor de monitoreo de carga no intrusivo (NILM) para agregarlos en HBSM',
    NILMDetailsTabSubHeader: 'Detalles del medidor NILM',
    NILMMeterId: 'ID/UUID de datos',
    NILMDISAGGREGATEDMETERID: 'ID/UUID de datos desagregados (opcional)',
    NILMMeterName: 'Nombre del medidor',
    NILMAddMeter: 'Añadir medidor',
    NIMAssignMainMeter: 'Asignar como medidor principal',
    NILMNextButton: 'Siguiente',
    NILMSubmitButtom: 'Enviar',
    NILMCancelButton: 'Cancelar',
    NILMcardheader: 'Monitoreo de carga no intrusivo (NILM)',
    NILMcardsubheader:
      'Determine el desglose del consumo de energía de su sitio por tipos de equipos',
    NILMRedirect: 'Será redirigido en 5 s',
    NILMAccountVerification: 'Verificación de cuenta en proceso',
    NILMAccountVerificationSuccess:
      'La verificación de la cuenta ha sido exitosa',
    INVALIDNILMMETERID: 'ID de instalación del medidor no válido',
    METERNAMEINVALID: 'El nombre del medidor ya existe para el sitio.',
    NILMMainmeter: '(Asignado como medidor principal)',
    NILMsmartXmeterheader:
      'A continuación se muestran sus medidores NILM. Por favor verifique para continuar y haga clic en enviar.',
    NILMDUPLICATEMETERNAME: 'nombre duplicado del medidor',
    NILMDUPLICATEMETERID: 'identificación duplicada del medidor',
    IDDUPLICATETOGETHER: 'UUID inválido y duplicado',
    NAMEDUPLICATETOGETHER: 'El nombre del medidor ya existe y está duplicado.'
  },
  energyStar: {
    EnergySubcriptionPeriod: 'Para el período de 12 meses que finaliza -',
    NoRecordsFound: 'No se encontraron registros',
    LearnText: 'Más información',
    outOfHundred: '/100',
    CurrentScore: 'Puntuación actual',
    EnergyTooltipHeader: 'Consumo de energía',
    EnergyTooltipContent:
      'La puntuación Energy Star es una medida del rendimiento de su propiedad en relación con propiedades similares, cuando se normaliza según las características climáticas y operativas.',
    EnergyStarTitle: 'Puntuación Energy Star',
    loading: 'Cargando',
    ViewText: 'Ver detalles de puntuación',
    NA: 'N/C',
    SomethingWentWrong: 'Nota',
    notifyServerError:
      'Hay algún error del lado del servidor. Por favor, póngase en contacto con el administrador del sistema.',
    ReasonForNoScoreLabel:
      'La puntuación Energy Star no se pudo cargar debido a algunos errores técnicos.',
    ViewReasonForNoScore: 'Ver motivo por la falta de detalles de puntuación',
    EnergyStarNoScoreNote:
      'La puntuación Energy Star mostrada es de {prevMonth}, ya que la puntuación del mes anterior no está disponible.',
    EnergyStarNoScoreNoContentMessage:
      '¡No se encontró motivo para la falta de información de puntuación!',
    EnergyStarNoScoreForLastMonthLabel:
      'No se pudo cargar la puntuación Energy Star del mes anterior. Por lo tanto, se muestra la puntuación del mes reciente.'
  },
  equipmentSpaceMapping: {
    FILE_NOT_ACCEPTED:
      '"{fileName}" es un formato de archivo no válido. Se aceptan únicamente archivos con formato .{extension}',
    INVALIDFILE_EXTENSION:
      'Extensión de archivo no válida. Utilice un archivo .{extension} válido.',
    INVALIDFILE_MIME:
      'Tipo de archivo MIME no válido. Utilice un archivo con tipos MIME válidos: {mimeTypes}.',
    INVALIDFILE_MAXALLOWEDSIZE:
      'El tamaño del archivo debe ser menor que {size}',
    INVALIDFILE_MINALLOWEDSIZE:
      'El tamaño del archivo debe ser mayor que {size}',
    INVALIDFILE_UNKNOWNERROR:
      'Se produjo algún error al acceder a la información del archivo. No se puede validar',
    INVALID_SCHEMA_REQUIRED_HEADERS:
      'El archivo de Excel cargado tiene columnas no válidas. Utilice la plantilla adecuada y vuelva a cargar el archivo Excel.',
    INVALID_SCHEMA_LIST_REQ_HEADERS:
      'Encabezados obligatorios: {requiredSubHeaders}',
    EMPTY: '',
    NO_DATA: 'El archivo no tiene ningún dato.',
    INVALID_DATA_CONTENT:
      'La primera fila de datos debe contener un elemento espacial.',
    SOME_ERROR_EXCEL_READ:
      'Se produjo algún error al leer el archivo Excel. Error: {errorString}',
    SOME_ERROR_GENERAL:
      'Se produjo algún error. Vuelva a seleccionar y cargue un archivo válido. Detalles del error -> {errorString}',
    PROPERTY_INVALID_DATA_TYPE: 'Tipo de datos no válido. Se permite: {type}',
    NAME_INVALID_SPECIAL_CHAR: 'El nombre tiene un carácter especial no válido',
    NAME_INVALID_MAX_LEN: 'Máximo {len} caracteres permitidos',
    SPATIAL_ELE_NEW: 'Se creará una nueva área',
    NO_ASSOC_REMOVE:
      'No hay ningún sensor VAV/de ocupación asignado. Elimine esta entrada',
    PROPERTIES_INVALID: 'Algunas propiedades no son válidas',
    SPATIAL_ELEMENT_NAME_MISMATCH:
      'Para el ID de elemento espacial proporcionado ({id}), el nombre de la hoja y el que está registrado en el sitio ({dbSpEleName}) no coinciden.',
    ELEMENT_NAME_MISMATCH:
      'Para el ID del elemento proporcionado ({id}), el nombre de la hoja y el que está registrado en el sitio ({dbEleName}) no coinciden.',
    DUPLICATE_ENTRIES: 'Varias entradas con el mismo nombre',
    MULTIPLE_EQUIPMENTS_SAME_NAME:
      'El sitio tiene varios equipos registrados con el mismo nombre. Cambie el nombre de este equipo a un nombre único para asociarlo.',
    ELEMENT_ID_DNE: '{type} con el id proporcionado ({id}) no existe',
    SPATIAL_ELEMENT_ID_DNE: 'El área con el Id proporcionado ({id}) no existe',
    ELEMENT_TYPE_NAME_DNE: '{type} con este nombre no existe',
    PROPERTY_DNE: 'La propiedad con nombre {name} no existe. Compruebe'
  },
  ZLOOnboardingConfig: {
    UPLOAD_CARD_TITLE_ZLO:
      'Asignación y configuración del espacio de equipos ZLO',
    UPLOAD_CARD_DESC_ZLO:
      'Cargar datos de asignación de equipos a espacios para la incorporación y configuración de ZLO',
    UPLOAD_MODAL_TITLE: 'Cargar datos de incorporación de ZLO',
    VALIDATE_DATA: 'Cargar',
    BACK_TO_UPLOAD: 'Atrás',
    UPLOAD_TAB_TOP_NOTE:
      'Descargue la plantilla y complete los detalles del elemento espacial junto con los detalles relacionados con el equipo en la plantilla antes de continuar con la carga.',
    UPLOAD_TAB_DOWNLOAD_TEMPLATE_BTN: 'Descargar la plantilla XLSX',
    UPLOAD_TAB_SECOND_NOTE: '(Solo es posible realizar una carga a la vez)',
    UPLOAD_TAB_PLACEHOLDER: 'Arrastre y suelte el archivo aquí',
    VALIDATING_FILE_DATA: 'Validación de datos de archivo',
    READING_FILE: 'Leyendo archivo',
    VALIDATING_FILE_SCHEMA: 'Validación del esquema de archivo',
    RETRIEVING_SITE_DATA: 'Recuperación de datos del sitio para validación',
    VALIDATING_DATA_ENTRIES: 'Validación de datos',
    ALL_ENTRIES_VALID: 'Todas las entradas son válidas',
    SUBMIT_TO_PROCEED_SUBTEXT:
      'Haga clic en enviar para continuar y registrarse en HBSM.',
    VIEW_ALL_ENTRIES: 'Ver todas las entradas',
    FIX_VAL_ERRORS_MSG:
      'A continuación, se muestran las entradas erróneas de datos de configuración e incorporación de ZLO. Regrese a la pestaña de carga y vuelva a subir el archivo Excel sin las entradas erróneas para registrarse en HBSM.',
    VAL_OK_SUBMIT_MSG:
      'Haga clic en enviar para continuar y registrarse en HBSM.',
    ERROR_BOX_TEXT:
      '{numErrors} errores identificados. Rectifíquelos y vuelva a subir el archivo para enviarlo y registrarse en HBSM.',
    VALIDATION_ERROR_TITLE: 'Error en la validación',
    TOTAL: 'Total',
    CURRENTLY_SHOWING: 'Mostrando {num} de {total} en total',
    SHOW_ALL_ENTRIES: 'Mostrar todas las entradas',
    SL_NO: 'N.° Sl',
    SPATIAL_ELE_NAME: 'Nombre del elemento espacial',
    ELE_TYPE: 'Tipo de elemento',
    ELE_NAME: 'Nombre',
    ZLO_STATE: 'Estado ZLO',
    ZO_SETBACK: 'Restablecimiento de optimización de zona (F)',
    VAV: 'Volumen de aire variable',
    OCCUPANCY_SENSOR: 'Sensor de ocupación',
    VAV_ETYPE: 'VAV',
    OCCUPANCY_SENSOR_ETYPE: 'Sensor de ocupación',
    SEARCH_PLACEHOLDER: 'Buscar',
    SEARCH_MIN_LEN: 'Mín {len} caracteres',
    NO_DATA: 'Ningún dato coincide con su búsqueda',
    VALIDATING_TITLE: 'Validando el archivo cargado',
    SOME_ERROR_FETCHING_DATA:
      'Se produjo algún error al obtener datos del sitio. Error: {errorString}',
    SUBMITTING_TITLE: 'Espere mientras mapeamos el equipo al espacio.',
    SUBMITTING_SUBTITLE: 'Será redirigido en unos segundos.',
    CREATING_NEW_SPATIAL_ELEMENTS: 'Creando nuevos espacios',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS: 'Asignación de equipos a espacios',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS_ERROR_MESSAGE:
      'Algún error al asignar un elemento a un elemento espacial. Intente nuevamente más tarde',
    UPDATING_PROPERTIES: 'Actualizando propiedades',
    SUBMISSION_SUCCESS_TITLE: 'La asignación del equipo al espacio fue exitoso',
    SUBMISSION_ERROR_TITLE: 'Error al enviar datos',
    SUBMISSION_ERROR_MESSAGE:
      'Se produjo algún un error al enviar datos. Intente nuevamente más tarde',
    BULK_CREATION_ERROR_MESSAGE:
      'Se produjo un error al crear elementos espaciales. Intente nuevamente más tarde.',
    UPDATE_PROPERTY_ERROR_MESSAGE:
      'Se produjo un error al actualizar las propiedades. Intente nuevamente más tarde.',
    SUBMISSION_SUCCESS_SUBTITLE:
      'Los sensores VAV y de ocupación asignados a los espacios se reflejarán en la pestaña de los equipos en la página de inicio del sitio.',
    GOTO_SITE_HOME_PAGE: 'Ir a la página de inicio del sitio',
    'Items per Page': 'Filas por página'
  },
  utilityBreakDown: {
    SUMMARYTABLESUBHEADER:
      'La información siguiente siempre se muestra según el ciclo de información de facturación'
  },
  UtilityBuilder: {
    NEWBILL: 'Nueva factura',
    ENTERDATAMANUALLY: 'Ingresar datos manualmente',
    BILLNAME: 'Nombre de la factura',
    BILLINGDATE: 'Fecha de facturación',
    TOTAL_BILL_AMOUNT: 'Monto total de la factura',
    BILLING_PERIOD_CONSUMPTION: 'Consumo del período de facturación',
    BILLING_DEMAND: 'Demanda de facturación',
    ENTER_PLACEHOLDER: 'Ingresar',
    SELECTENTER_PLACEHOLDER: 'Seleccionar',
    SELECT: 'Seleccionar',
    CATEGORIES: 'Categorías',
    ACCOUNTNUMBER: 'Número de cuenta',
    UTILITYTYPE: 'Tipo de servicio público',
    BILLINGCYCLE: 'Ciclo de facturación',
    UPLOADELECTRICITYBILL: 'Subir factura de electricidad',
    UPLOADGASBILL: 'Subir factura de gas',
    ADDELECTRICITYBILL: 'Añadir factura de electricidad',
    ADDGASBILL: 'Agregar factura de {utilityType}',
    UPLOADUTILITYBILL: 'Subir factura de servicios públicos',
    PDFUPLOADPROMPT:
      'Por favor, cargue un archivo PDF de la factura de servicios públicos.',
    UploadElectricitybill: 'Subir factura de electricidad*',
    Utilitybill: 'Factura de servicios públicos',
    UPLOADBILL: 'Subir factura de {utilityType}',
    UPLOADELECTRICITYBILLNONMANDATORY: 'Subir factura de electricidad',
    FILENAMECONTAINSPACES: 'El nombre del archivo contiene espacios.',
    FILENAMECONTAINSPECIALCHARACTER:
      'El nombre del archivo contiene caracteres especiales.',
    PDFEXTENSION: '.pdf',
    BILLCATEGORIES: 'Categorías de facturas',
    REFERSAMPLEBILL: 'Consulte la factura de muestra.',
    INPUTCATEGORIES:
      'Ingrese las diferentes categorías y los costos correspondientes de su factura de {tipoDeServicio}. Si necesita ayuda para localizarlos en la factura, '
  },
  baseline: {
    baselineconfiguration: 'Configuración de referencia',
    baselineConfigDesc:
      'Las líneas de base ajustadas establecen el consumo esperado del servicio público para un sitio, basándose en una combinación de consumo histórico, tendencias recientes e impactos conocidos, como variables climáticas.',
    baseline: 'Referencia',
    total: 'Total',
    searchPlaceholder: 'Buscar',
    create: 'Crear referencia',
    view: 'Ver línea base',
    baselineQuality: 'Calidad de referencia',
    baselinePeriod: 'Período de referencia',
    reportingPeriod: 'Período del informe',
    estBaselinePeriod: 'Establecer período de referencia',
    baselinePeriodDescription:
      'Seleccione el período de referencia y el período de informe para el que necesita crear la línea de base',
    independentVariables: 'Variables independientes',
    autoSelectBest: 'Seleccionar automáticamente las mejores variables',
    utilityDataType: 'Tipo de datos de servicios públicos',
    calendarMonth: 'Mes civil',
    billingPeriod: 'Periodo de facturación',
    tStat: 'Estadísticas T'
  },
  utilityManagement: {
    ADD_ACCOUNT: 'AGREGAR CUENTA',
    ADD_METERS: 'AGREGAR MEDIDORES'
  }
};

export const nonDescriptorMessages: Record<string, string> = {
  'TOTAL BILL AMOUNT': 'Monto total de la factura',
  Consumption: 'Consumo',
  Demand: 'Demanda',
  'Service Charges': 'Cargos por servicio',
  'Transmission & Distribution': 'Transmisión y distribución',
  Others: 'Otros',
  'Demand Charges': 'Cargos por demanda',
  'Total Cost': 'Costo total',
  Total: 'Total'
};
